import { Component, OnInit } from '@angular/core';
import { FirmaService } from '../_services/firma.service';

@Component({
  selector: 'app-firmalar',
  templateUrl: './firmalar.component.html',
  styleUrls: ['./firmalar.component.css']
})
export class FirmalarComponent implements OnInit {
search:any;
page=1;
firmalar:any[];
  constructor(private firmaService:FirmaService

  ) { }

  ngOnInit() {
  }


  ara(){
      this.firmaService.ara(this.search,this.page).subscribe(res=>{
          this.firmalar=res;
      });
  }

}
